<script>
export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      title: "",
      message: ""
    }
  },

  created() {
    this.title = this.$t('confirmation');
    this.message = this.$t('areYouSure');
  },

  computed: {
    showModal: {
      get() {
        return this.modal
      },

      set(newVal) {
        this.$emit('update:modal', newVal)
      },
    },
  },
}
</script>
<template>
  <b-modal v-model="showModal" :title="title" @ok="$emit('confirmed')" :ok-title="$t('global.yes')" ok-only>
    <div>{{ this.message }}</div>
  </b-modal>
</template>
